import { render, staticRenderFns } from "./staff_list.vue?vue&type=template&id=5f7d87ba"
import script from "./staff_list.vue?vue&type=script&lang=js"
export * from "./staff_list.vue?vue&type=script&lang=js"
import style0 from "./staff_list.vue?vue&type=style&index=0&id=5f7d87ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports